import { render } from "./masonryPage.vue?vue&type=template&id=a5202e0c"
import script from "./masonryPage.vue?vue&type=script&lang=js"
export * from "./masonryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__